<template>
  <b-col lg="2" md="12" sm="12" class="">

    <div dir="ltr" class="nav-main-menu-6 ">
      <b-dropdown :text="item.name" variant="transparent" class="d-inline"
                  v-if="item.children.length!==0">
        <b-nav-item class=" " :href="child.url" v-for="child in item.children" :key="child.id">{{ child.name }}&MediumSpace;
          <m-icon class="m-0" :icon="child.icon_class" />
        </b-nav-item>

      </b-dropdown>

      <b-nav-item :href="item.url" class="d-inline" v-else>{{ item.name }} &MediumSpace;
        <m-icon class="m-0" :icon="item.icon_class"/>
      </b-nav-item>

    </div>
  </b-col>


</template>

<script>

export default {
  name: "NavMenuItem",
  props: ['item'],
}
</script>

<style>
.nav-main-menu-6 li a {
  font-weight: 100 !important;
  color: white !important;
}
</style>